import { tableFiltersUrl } from '../../utils/helper'
import request from '../axiosInterceptor'

const api = {
  getAllOrganisations(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/organisation-list?${tableFiltersUrl(data)}`,
      method: 'get',
    })
  },
  getSubsidiaryDetail(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/subsidiary-details?subsidiary_master_id=${data}`,
      method: 'get',
    })
  },
  postAddOrganisation(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/add-organisation`,
      method: 'post',
      data: data,
    })
  },
  putEditOrganisation(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/edit-organisation`,
      method: 'put',
      data: data,
    })
  },
  getOrganisationUsers(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/organisation-user-list?organisation_master_id=${data?.organization_id}&${tableFiltersUrl(data?.tableFilters)}`,
      method: 'get',
    })
  },
  getSubsidiaryUsers(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/subsidiary-user-profile-list?subsidiary_master_id=${data?.id}&${tableFiltersUrl(data?.tableFilters)}`,
      method: 'get',
    })
  },
  getOrganisationUsersByEmail(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/subsidiary-wise-user-profile?organisation_master_id=${data?.organization_id}&email=${data?.email}&${tableFiltersUrl(data?.tableFilters)}`,
      method: 'get',
    })
  },
  getAllSubsidiaries(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/subsidiary-list?organization_master_id=${data?.organization_id}&${tableFiltersUrl({ ...data?.tableFilters, pagination: { pageIndex: data?.tableFilters?.pagination?.pageIndex || 0, pageSize: 50 } })}`,
      method: 'get',
    })
  },
  postAddSubsidiary(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/add-subsidiary`,
      method: 'post',
      data: data,
    })
  },
  putEditSubsidiary(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/edit-subsidiary-details`,
      method: 'put',
      data: data,
    })
  },
  getMasterConfiguration(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/masters-configuration?organization_master_id=${data?.organization_id}`,
      method: 'get',
    })
  },
  getMasterConfigurationTable(data: any, inputType: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/master/${inputType}?organization_master_id=${data?.organization_id}`,

      method: 'get',
    })
  },
  getMasterConfigurationLog(data: any, name: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/org-alias-change-logs?organization_master_id=${data?.organization_id}&attribute_name=${name}`,

      method: 'get',
    })
  },
  postUpdateAliases(data: any, id: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/organization/${id}/update-alias`,
      method: 'post',
      data: data,
    })
  },
  // Linked Projects APIs
  getLinkedProjects(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/list-linked-projects?organization_id=${data?.organization_id}`,
      method: 'get',
    })
  },
  saveLinkedProjects(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/add-linked-projects`,
      method: 'post',
      data: data,
    })
  },
  deleteLinkedProject(data: any) {
    return request({
      url: `${process.env.REACT_APP_API_BASEURL}v1/organisation/delete-linked-projects`,
      method: 'post',
      data: data,
    })
  },
}

export default api
